import { css } from 'emotion';

import { breakpoints, colors, fonts } from '../styles';

export const groupsTitle = css`
  margin: 20px 0 0 20px;
`;

const occupiedHeightExcludingGroupsContainer = '130px';

export const groupsContainerScroll = css`
  max-height: calc(40vh - ${occupiedHeightExcludingGroupsContainer});
  overflow-y: auto;

  scrollbar-gutter: stable;
  &::-webkit-scrollbar {
    width: 6px;
    background: #f3f1f1;
    border-radius: 50px;
  }
  &::-webkit-scrollbar-thumb {
    border: 2px solid #5d7186;
    border-radius: 6px;
    height: 20px;
    background-color: #5d7186;
    background-clip: content-box;
  }
`;

export const groupsContainer = css`
  margin: 10px 10px 10px 10px;
`;

export const placeholderContainer = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin: 30px;
`;

export const clearFilterButton = css`
  && {
    max-width: 90px;
    margin: 10px 10px 10px 20px;
    justify-content: flex-start;
  }
`;

export const filterOverlay = css`
  width: 320px;
  max-height: 420px;
`;

export const loadingContainer = css`
  margin: 40px;
  text-align: center;
`;

export const contentDivider = css`
  && {
    width: unset;
  }
`;

export const filterActions = css`
  display: flex;
  justify-content: space-between;
  margin: 20px;
`;

export const icon = css`
  margin-right: 10px;
`;

export const overlay = css`
  && {
    display: flex;
    flex-direction: column;
    width: 320px;
    box-sizing: border-box;

    @media screen and (max-width: ${breakpoints.tablet}) {
      width: 275px;
    }
  }
`;

export const cancelButton = css`
  && {
    margin-right: 40px;
    margin-left: auto;
  }
`;

export const vehicleGroupIcon = css`
  padding-right: 10px;
  box-sizing: content-box;
`;

export const createGroupButton = css`
  && {
    margin: 20px 0 10px;
  }
`;

export const noGroupsPlaceholder = css`
  white-space: normal;
  margin: 0;
`;

export const tooltipText = css`
  && {
    display: none;
    background-color: ${colors.black};
    color: ${colors.white};
    font-weight: ${fonts.weight.medium};
    font-size: ${fonts.size.smallest};
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;

    /* Position the tooltip text - see examples below! */
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
    z-index: 1;

    &&:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: ${colors.black} transparent transparent transparent;
    }
  }
`;

export const chipWrapper = css`
  position: relative;
  display: inline-block;
  padding: 2px;
  margin: 0 10px 10px 0;
  display: table;
  &:hover {
    .${tooltipText} {
      width: 100px;
      display: block;
    }
  }
`;

export const searchBox = css`
  width: 295px;
  margin-top: 10px;
  margin-right: 20px;
  margin-left: 10px;
`;

export const checkboxContainer = css`
  margin-top: 10px;
  margin-bottom: 10px;
`;
